if (typeof accordions == 'undefined') {
  const accordions = document.querySelectorAll("navigation-drawer .accordion");

const openAccordion = (accordion) => {
  const content = accordion.querySelector(".accordion__content");
  accordion.classList.add("accordion__active");
  content.style.maxHeight = content.scrollHeight + "px";
  if (accordion.dataset.promo) {
    displayPromo(accordion.dataset.promo);
  }
};

const closeAccordion = (accordion) => {
  const content = accordion.querySelector(".accordion__content");
  accordion.classList.remove("accordion__active");
  content.style.maxHeight = null;
};

const displayPromo = (promo) => {
  let promoBlock = document.querySelector(".mobile_promo_block.active");
  let promoTarget = document.querySelector(`.mobile_promo_block[data-promo="${promo}"]`)
  if(promoBlock == promoTarget) return;

  promoBlock.classList.remove("active");
  setTimeout(function(){
    promoBlock.style.display = "none";
    promoTarget.style.display = "";
    promoTarget.classList.add("active");
  }, 150)
}

accordions.forEach((accordion) => {
  const intro = accordion.querySelector(".accordion__intro");
  const content = accordion.querySelector(".accordion__content");

  intro.onclick = () => {
    intro.ariaExpanded = !intro.ariaExpanded;
    if (content.style.maxHeight) {
      closeAccordion(accordion);
    } else {
      openAccordion(accordion);
    }
  };
});
}